export class TradeUnexpectedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TradeUnexpectedError';
  }
}
